import React, { Component } from "react";
import PropTypes from "prop-types";
import Paginator from "paginator";
import Page from "./Page";
import cx from "classnames";
import { isPwa } from "../../../fanctionUtility"

export default class Pagination extends Component {
    static propTypes = {
        pagineTotali: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        activePage: PropTypes.number,
        itemsCountPerPage: PropTypes.number,
        pageRangeDisplayed: PropTypes.number,
        prevPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        nextPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        lastPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        firstPageText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        disabledClass: PropTypes.string,
        hideDisabled: PropTypes.bool,
        hideNavigation: PropTypes.bool,
        innerClass: PropTypes.string,
        itemClass: PropTypes.string,
        itemClassFirst: PropTypes.string,
        itemClassPrev: PropTypes.string,
        itemClassNext: PropTypes.string,
        itemClassLast: PropTypes.string,
        linkClass: PropTypes.string,
        activeClass: PropTypes.string,
        activeLinkClass: PropTypes.string,
        linkClassFirst: PropTypes.string,
        linkClassPrev: PropTypes.string,
        linkClassNext: PropTypes.string,
        linkClassLast: PropTypes.string,
        hideFirstLastPages: PropTypes.bool,
        getPageUrl: PropTypes.func
    };

    static defaultProps = {
        itemsCountPerPage: 10,
        pageRangeDisplayed: 5,
        activePage: 1,
        prevPageText: "⟨",
        firstPageText: "«",
        nextPageText: "⟩",
        lastPageText: "»",
        innerClass: "pagination justify-content-center",
        itemClass: "page-item",
        linkClass: "page-link",
        activeLinkClass: "page-item active",
        hideFirstLastPages: false,
        getPageUrl: (i) => "#"
    };

    isFirstPageVisible(has_previous_page) {
        const { hideDisabled, hideFirstLastPages } = this.props;
        return !(hideFirstLastPages || (hideDisabled && !has_previous_page));

    }

    isPrevPageVisible(has_previous_page) {
        const { hideDisabled, hideNavigation } = this.props;
        return !(hideNavigation || (hideDisabled && !has_previous_page));

    }

    isNextPageVisible(has_next_page) {
        const { hideDisabled, hideNavigation } = this.props;
        return !(hideNavigation || (hideDisabled && !has_next_page));

    }

    isLastPageVisible(has_next_page) {
        const { hideDisabled, hideFirstLastPages } = this.props;
        return !(hideFirstLastPages || (hideDisabled && !has_next_page));

    }

    buildPages() {
        const pages = [];
        const {
            itemsCountPerPage,
            pageRangeDisplayed,
            activePage,
            prevPageText,
            nextPageText,
            firstPageText,
            lastPageText,
            recordTotali,
            onChange,
            activeClass,
            itemClass,
            itemClassFirst,
            itemClassPrev,
            itemClassNext,
            itemClassLast,
            activeLinkClass,
            disabledClass,
            linkClass,
            linkClassFirst,
            linkClassPrev,
            linkClassNext,
            linkClassLast,
            getPageUrl
        } = this.props;

        const paginationInfo = new Paginator(
            itemsCountPerPage,
            pageRangeDisplayed
        ).build(recordTotali, activePage);

        for (let i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
            pages.push(
                <Page
                    isActive={i === activePage}
                    key={i}
                    href={getPageUrl(i)}
                    pageNumber={i}
                    pageText={i + ""}
                    onClick={onChange}
                    itemClass={itemClass}
                    linkClass={linkClass}
                    activeClass={activeClass}
                    activeLinkClass={activeLinkClass}
                />
            );
        }

        this.isPrevPageVisible(paginationInfo.has_previous_page) &&
            pages.unshift(
                <Page
                    key={"prev" + paginationInfo.previous_page}
                    pageNumber={paginationInfo.previous_page}
                    onClick={onChange}
                    pageText={prevPageText}
                    isDisabled={!paginationInfo.has_previous_page}
                    itemClass={cx(itemClass, itemClassPrev)}
                    linkClass={cx(linkClass, linkClassPrev)}
                    disabledClass={disabledClass}
                />
            );

        this.isFirstPageVisible(paginationInfo.has_previous_page) &&
            pages.unshift(
                <Page
                    key={"first"}
                    pageNumber={1}
                    onClick={onChange}
                    pageText={firstPageText}
                    isDisabled={!paginationInfo.has_previous_page}
                    itemClass={cx(itemClass, itemClassFirst)}
                    linkClass={cx(linkClass, linkClassFirst)}
                    disabledClass={disabledClass}
                />
            );

        this.isNextPageVisible(paginationInfo.has_next_page) &&
            pages.push(
                <Page
                    key={"next" + paginationInfo.next_page}
                    pageNumber={paginationInfo.next_page}
                    onClick={onChange}
                    pageText={nextPageText}
                    isDisabled={!paginationInfo.has_next_page}
                    itemClass={cx(itemClass, itemClassNext)}
                    linkClass={cx(linkClass, linkClassNext)}
                    disabledClass={disabledClass}
                />
            );

        this.isLastPageVisible(paginationInfo.has_next_page) &&
            pages.push(
                <Page
                    key={"last"}
                    pageNumber={paginationInfo.total_pages}
                    onClick={onChange}
                    pageText={lastPageText}
                    isDisabled={
                        paginationInfo.current_page === paginationInfo.total_pages
                    }
                    itemClass={cx(itemClass, itemClassLast)}
                    linkClass={cx(linkClass, linkClassLast)}
                    disabledClass={disabledClass}
                />
            );

        return pages;
    }

    render() {
        const style = {
            'color': '#007bff',
            'pointerEvents': 'none',
            'backgroundColor': '#fff',
            'borderColor': '#dee2e6',
            'marginLeft': '10px',
            'borderRadius': '0.25rem',
            'textAlign': 'center',
            'padding': '5px'
        };
        const pages = this.buildPages();
        return (
            <div>
                <ul className={this.props.innerClass} style={{ margin: 0 }} data-test='component-pagination'>
                {pages}
                {!isPwa() && (
                    <>
                        <li style={style}>
                            Record totali: {this.props.recordTotali}
                        </li>
                        <li style={style}>
                            Pagine totali: {this.props.pagineTotali}
                        </li>
                    </>
                )}
            </ul>
            {isPwa() && <div class="my-2">&nbsp;</div> }
            </div>
            
        );
    }

}
